import { Navigate, Route, Routes } from "react-router-dom";

import HomePage from "@/pages/HomePage";
import SignupPage from "@/pages/SignupPage";
import ApiReferencePage from "@/pages/glofox/ApiReferencePage";
import { GlofoxPortalDocRoute } from "@/pages/glofox/GlofoxPortalDocPage";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordConfirmPage from "@/pages/ResetPasswordConfirmPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import AdminForgotPasswordPage from "@/pages/admin/AdminForgotPasswordPage";
import AdminHomePage from "@/pages/admin/AdminHomePage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminMetricsPage from "@/pages/admin/AdminMetricsPage";
import AdminResetPasswordConfirmPage from "@/pages/admin/AdminResetPasswordConfirmPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import RequestAccessPage from "@/pages/glofox/RequestAccessPage";
import SandboxPage from "@/pages/glofox/SandboxPage";
import { GLOFOX_PORTAL_DOCS } from "@/content/glofox/portal-docs/manifest";
import { GLOFOX_REQUEST_ACCESS_HREF } from "@/lib/portal/glofox-routes";
import {
  getSolePlatformPath,
  hasMultiplePlatforms,
} from "@/lib/theme/resolvePlatform";

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          hasMultiplePlatforms() ? (
            <HomePage />
          ) : (
            <Navigate to={getSolePlatformPath()} replace />
          )
        }
      />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route
        path="/forgot-password/confirm"
        element={<ResetPasswordConfirmPage />}
      />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route
        path="/admin/forgot-password"
        element={<AdminForgotPasswordPage />}
      />
      <Route
        path="/admin/forgot-password/confirm"
        element={<AdminResetPasswordConfirmPage />}
      />
      <Route path="/admin/control-panel" element={<AdminHomePage />} />
      <Route path="/admin/metrics" element={<AdminMetricsPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route
        path="/admin"
        element={<Navigate to="/admin/control-panel" replace />}
      />
      <Route
        path="/admin/drawer"
        element={<Navigate to="/admin/control-panel" replace />}
      />
      <Route path={GLOFOX_REQUEST_ACCESS_HREF} element={<RequestAccessPage />} />
      {GLOFOX_PORTAL_DOCS.map((doc) => (
        <Route
          key={doc.id}
          path={doc.route}
          element={<GlofoxPortalDocRoute route={doc.route} />}
        />
      ))}
      <Route path="/glofox/api-reference" element={<ApiReferencePage />} />
      <Route
        path="/glofox/get-started"
        element={<Navigate to="/glofox" replace />}
      />
      <Route
        path="/glofox/signup"
        element={<Navigate to="/signup" replace />}
      />
      <Route
        path="/glofox/login"
        element={<Navigate to="/login" replace />}
      />
      <Route path="/glofox/sandbox" element={<SandboxPage />} />
    </Routes>
  );
}
